import styled from 'styled-components';

import { heading } from '@constants/fonts';

export const ListTitle = styled.div<{
  titleTransparent: boolean;
  titleColor?: string;
}>`
  padding-left: 4%;
  height: 60px;
  ${(props) =>
    !props.titleTransparent && `box-shadow: ${props.theme.shadows[24]}`};
  background-color: ${(props) =>
    props.titleColor ?? props.theme.palette.background.paper};
  font-family: ${heading};
  font-size: 16px;
  vertical-align: middle;
  line-height: 60px;
  font-weight: 500;
`;

export const OuterDiv = styled.div<{ titleTransparent: boolean }>`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  ${(props) =>
    !props.titleTransparent && `box-shadow: ${props.theme.shadows[24]}`};
`;
